/**
 * JELTR events – single source of truth for JELTR news and timeline.
 * Used by: PromotionalHome.js (news, timeline) via siteEvents.
 */

import { getEventImagePath } from './eventPaths';

export const JELTR_EVENTS = [
  {
    slug: 'call-for-papers-2026',
    path: '/jeltr/call-for-papers-2026',
    title: 'Call for Papers 2026',
    shortDescription: 'Manuscript submissions for JELTR are now open to undergraduates seeking a platform for their research.',
    longDescription:
      'Manuscript submissions for JELTR are now open. If you are an undergraduate seeking to give your research a platform, this is the perfect opportunity. Submissions must be original, previously unpublished work and should be full manuscripts that follow the JELTR manuscript guidelines enclosed within the submission form.',
    accentColor: 'purple',
    showInNav: true,
    showInNews: true,
    newsDateLabel: 'Sep 2026',
    newsCategory: 'Call for Papers',
    newsBlurb:
      'Manuscript submissions for JELTR are now open. Original, previously unpublished full manuscripts only; please follow the JELTR guidelines in the submission form. Deadline: 1 September 2026.',
    order: 2,
    sortDate: '2026-09-01',
    posterImage: getEventImagePath('jeltr', 'papers-2026', 'Poster.png'),
    posterAlt: 'JELTR Call for Papers 2026 Poster',
    ctaLabel: 'Submit Manuscript',
    ctaHref: 'https://forms.gle/HYF4mCfiHzueupJy7',
    timelineEntries: [
      { date: 'Sep 1', label: 'JELTR Call for Papers Deadline' },
    ],
  },
  {
    slug: 'jeltr-issue-release',
    path: '/jeltr',
    title: 'JELTR Issue Release',
    shortDescription: 'Journal of Experiential Learning & Transdisciplinary Research – publication opportunities for UG students.',
    accentColor: 'purple',
    showInNav: false,
    showInNews: false,
    newsDateLabel: 'Sep - Oct 2026',
    newsCategory: 'Publication',
    newsBlurb: 'New issue of the Journal for Experiential Learning and Transdisciplinary Research. Formal publication opportunities for undergraduate students.',
    order: 1,
    sortDate: '2026-10-01',
    timelineEntries: [
      { date: 'Sep - Oct', label: 'JELTR Issue Release' },
    ],
  },
];

/** Sorted reverse chronologically (newest first) */
export const getJeltrEventsForListing = () =>
  [...JELTR_EVENTS].sort((a, b) => (b.sortDate || '0000-01-01').localeCompare(a.sortDate || '0000-01-01'));

export const getJeltrEventsForNews = () =>
  getJeltrEventsForListing().filter((e) => e.showInNews);

export const getJeltrTimelineEntries = () =>
  getJeltrEventsForListing().flatMap((event) =>
    (event.timelineEntries || []).map((entry) => ({
      date: entry.date,
      label: entry.label,
      path: event.path,
      accentColor: event.accentColor,
      sortDate: event.sortDate,
    }))
  );

/** Get a single JELTR event by slug (e.g. for event pages that read details from config). */
export const getJeltrEventBySlug = (slug) =>
  JELTR_EVENTS.find((e) => e.slug === slug) ?? null;

/** Events to show in the JELTR nav dropdown */
export const getJeltrEventsForNav = () =>
  getJeltrEventsForListing().filter((e) => e.showInNav);
